export default "__VITE_ASSET__b8ca5e97__"